<template>
  <span>
    <div class="columns">
      <div class="column is-12">
        <div class="box content">
          <h2 class="title is-4">{{ $t('submit_claim.new_claim') }}</h2>
          <hr>
          <div :key="gcFormKey" ref="gcFormContainer">
            <!-- <GeniusGCForm :upload-host="urls.FILE_UPLOAD_URL" :makes="makes" :models="models" :states="states" @submit="submitToPipeline" @getModels="getModels" /> -->
            <component
              :is="pageComponents.gcForm"
              :upload-host="urls.FILE_UPLOAD_URL"
              :makes="makes"
              :models="models"
              :states="states"
              :template-id="$cgiSettings.templateId"
              @submit="submitToPipeline"
              @getModels="getModels"
            />
          </div>
        </div>
      </div>
    </div>
  </span>
</template>
<script>
import urls from '../../urls';

export default {
  name: 'ClaimSubmit',
  data() {
    return {
      gcFormKey: '',
      vinSelection: null,
      claimData: {
        loss_year: null,
      },
      makes: [],
      models: [],
      states: [],
      allMakeModels: [],
      urls,
      pageComponents: {
        gcForm: this.$cgiComponents.gcForm,
      },
    };
  },
  mounted() {
    this.loadDefaults();
  },
  methods: {
    async loadDefaults() {
      const loadingComponent = this.$buefy.loading.open({
        container: this.$refs.gcFormContainer.$el,
      });
      await Promise.all([this.getMakes(), this.getStates()]);
      this.gcFormKey = Math.random();
      loadingComponent.close();
    },
    async submitToPipeline(claimDetails) {
      const payload = JSON.parse(JSON.stringify(claimDetails));
      payload.country = window.localStorage.getItem('region');
      // payload.loss_year = '2019';
      payload.request_type = 'GC';
      payload.pipeline = 'genius-claim';
      const response = await this.$http.post('claims', payload);
      if (response) {
        this.$router.push({
          name: 'ClaimDetails',
          params: { claimUID: response.id },
        });
      }
    },
    async getMakes() {
      // this.makes = await this.$http.get('meta/makes');
      this.allMakeModels = await this.$http.get('meta/makes-models');
      if (this.allMakeModels && this.allMakeModels.length > 0) {
        this.makes = this.allMakeModels.map((x) => ({
          id: x.id,
          common_name: x.make_name,
        }));
      }
    },
    async getStates() {
      this.states = await this.$http.get('meta/states');
    },
    async getModels(makeId) {
      // this.models = await this.$http.get(`meta/models/${makeId}`);
      if (this.allMakeModels && this.allMakeModels.length > 0) {
        const selectedMake = this.allMakeModels.find((x) => x.id === makeId);
        if (selectedMake && selectedMake.models) {
          this.models = selectedMake.models.map((x) => ({
            id: x.id,
            common_name: x.model_name,
          }));
        }
      }
    },
  },
};
</script>
